import { rangePresets, defaultRangePreset } from '@gogame/intl-ts';
import { object, number, array, string } from '@gogame/schemas';

import {
  FILTER_ADDED,
  FILTER_MASTER_CAMPAIGNS,
  FILTER_APPLICATIONS,
} from 'scenes/Influencers/Briefs/constants';

export const EMPTY_FILTERS = {
  [FILTER_ADDED]: rangePresets.LIFETIME.value,
};

export const filtersSchema = object({
  [FILTER_ADDED]: array(string()).constants(defaultRangePreset),
  [FILTER_MASTER_CAMPAIGNS]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
}).default({
  [FILTER_ADDED]: rangePresets.THIS_PLUS_NEXT_MONTH.value,
});
